<template lang="pug">
#GroupForm
  b-form(@submit.stop.prevent="onSubmit" novalidate)
    b-row

      b-col(cols="12")
        b-form-group(label="Nombre" label-for="input-name")
          b-form-input(
            id="input-name" 
            v-model="form.name" 
            placeholder="Nombre"
            :state="$v.$dirty ? !$v.form.name.$invalid : null"
          )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.name.required") Campo requerido

      b-col(cols="12")
        b-form-group(label="Descripción" label-for="input-description")
          b-form-textarea(
            id="input-description" 
            v-model="form.description" 
            placeholder="Descripción"
          )
          
    .modal-footer
      b-button(v-if="!editMode" variant="outline-muted" @click="$emit('close')") Cancelar
      b-button.btn-create(type="submit") {{ editMode ? 'Guardar': 'Crear' }}
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    form: {
      name: { required }
    }
  },
  data() {
    return {
      form: {
        name: '',
        description: ''
      }
    }
  },
  methods: {
    ...mapActions(['getBusinessGroup', 'createBusinessGroup', 'updateBusinessGroup']),
    async onSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        console.log('asds')
      } else {
        console.log('asd')
        let response = null
        if (this.editMode) {
          response = await this.updateBusinessGroup({ data: this.form, groupId: this.businessGroup.id })
        } else {
          response = await this.createBusinessGroup({ data: this.form })
        }
        
        this.$root.$bvToast.toast(response.ok ? 'Grupo guardado correctamente' : 'Error al guardar el Grupo', 
        {
          title: response.ok ? 'Éxito!' : 'Ocurrió un error!',
          variant: response.ok ? 'success' : 'danger'
        })
        this.getBusinessGroup({ groupId: this.$route.params.groupId })
        this.$emit('done')
      }
    }
  },
  computed: {
    ...mapGetters(['businessGroup'])
  },
  async created () {
    if (this.editMode) {
      await this.getBusinessGroup({ groupId: this.$route.params.groupId })
      const { name, description } = this.businessGroup
      this.form = { name, description }
    }
  }
}
</script>